import { BackLink } from "nhsuk-react-components"
import { type MouseEventHandler } from "react"
import "./NavigateBack.scss"

const NavigateBack = ({ onClick }: { onClick: MouseEventHandler }): JSX.Element => {
  return (
    <div className="nhsuk-width-container back-bar">
      <BackLink asElement="button" onClick={onClick}>
        Back
      </BackLink>
    </div>
  )
}
export default NavigateBack
